// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participant-info-header {
	position: relative;
	padding: 41px 16px 30px 97px;
}

.participant-info-header .profile-photo-wrapper {
	position: absolute;
	top: 32px;
	left: 15px;
}

.participant-info-header .participant-info {}

.participant-info-header .participant-info .participant-name {
	font-weight: bold;
	font-size: 34px;
	line-height: 34px;
}

.participant-info-header .participant-info .participant-email {
	font-size: 15px;
	color: #8F8E93;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/ParticipantInfoHeader.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA,4CAA4C;;AAE5C;CACC,iBAAiB;CACjB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,cAAc;AACf","sourcesContent":[".participant-info-header {\n\tposition: relative;\n\tpadding: 41px 16px 30px 97px;\n}\n\n.participant-info-header .profile-photo-wrapper {\n\tposition: absolute;\n\ttop: 32px;\n\tleft: 15px;\n}\n\n.participant-info-header .participant-info {}\n\n.participant-info-header .participant-info .participant-name {\n\tfont-weight: bold;\n\tfont-size: 34px;\n\tline-height: 34px;\n}\n\n.participant-info-header .participant-info .participant-email {\n\tfont-size: 15px;\n\tcolor: #8F8E93;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
